import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Select } from 'site-modules/shared/components/select/select';
import { PAYMENT_INPUT_PROPS, TERM_NAME, TERM_OPTIONS, TOOLTIPS } from 'site-modules/calculators/constants/calculators';
import { PaymentInput } from 'site-modules/shared/components/calculator/payment-input/payment-input';
import { CalculatorRowItem } from 'site-modules/calculators/components/calculator-row-item/calculator-row-item';
import { AffordabilityCalculatorTitleWrapper } from 'site-modules/calculators/components/affordability-calculator-title-wrapper/affordability-calculator-title-wrapper';

/**
 * Renders affordability calculator finance step.
 * @param {number} monthlyPayment
 * @param {number} marketFinanceRate
 * @param {number} term
 * @param {function} onInputChange
 * @param {function} onKeyPress
 * @param {function} onTermChange
 * @returns {ReactElement}
 */
export function AffordabilityCalculatorStepFinance({
  monthlyPayment = 0,
  marketFinanceRate = 0,
  term = 0,
  onInputChange,
  onKeyPress,
  onTermChange,
}) {
  return (
    <Fragment>
      <CalculatorRowItem
        title="Your target monthly payment"
        tooltip={TOOLTIPS.MONTHLY_PAYMENT}
        TitleWrapper={AffordabilityCalculatorTitleWrapper}
      >
        <PaymentInput
          name="monthlyPayment"
          key={monthlyPayment}
          value={monthlyPayment}
          onKeyPress={onKeyPress}
          onBlur={onInputChange}
          inputAriaLabel="Your target monthly payment"
          isCurrency
          {...PAYMENT_INPUT_PROPS}
        />
      </CalculatorRowItem>
      <CalculatorRowItem title="Loan term" subtitle="(months)" TitleWrapper={AffordabilityCalculatorTitleWrapper}>
        <Select
          name={TERM_NAME}
          options={TERM_OPTIONS}
          value={term.toString()}
          onChange={onTermChange}
          labelText="Select loan term"
          inputClassName="calculator-select form-control-sm form-control ps-0"
          isLabelHidden
        />
      </CalculatorRowItem>
      <CalculatorRowItem
        title="Estimated Rate"
        tooltip={TOOLTIPS.MARKET_RATE}
        TitleWrapper={AffordabilityCalculatorTitleWrapper}
        overrideWrapperClass
      >
        <PaymentInput
          name="marketFinanceRate"
          key={marketFinanceRate}
          value={marketFinanceRate}
          onKeyPress={onKeyPress}
          onBlur={onInputChange}
          {...PAYMENT_INPUT_PROPS}
          isPercentage
          inputAriaLabel="Estimated Rate"
        />
      </CalculatorRowItem>
    </Fragment>
  );
}

AffordabilityCalculatorStepFinance.propTypes = {
  onInputChange: PropTypes.func.isRequired,
  onTermChange: PropTypes.func.isRequired,
  onKeyPress: PropTypes.func.isRequired,
  monthlyPayment: PropTypes.number,
  marketFinanceRate: PropTypes.number,
  term: PropTypes.number,
};
